import { render } from "./home-benefits.vue?vue&type=template&id=5cc83281&scoped=true"
import script from "./home-benefits.vue?vue&type=script&lang=js"
export * from "./home-benefits.vue?vue&type=script&lang=js"

import "./home-benefits.vue?vue&type=style&index=0&id=5cc83281&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cc83281"]])

export default __exports__